import React, {useEffect} from 'react';
import {Outlet, useSearchParams} from 'react-router-dom';
import {useShallow} from 'zustand/react/shallow';
import usePurchaseProcessEndedEvent from '@contentlab/hooks/analytics/use-purchase-process-ended-event';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';
import {
  getContentLabWebPaymentIds,
  removeContentLabWebPaymentIds,
} from '@/utils/LtidStorage';
import DoAndDontModal from '@/views/content-studio/components/do-and-dont-modal';
import {ContentStudioPricingModal} from '@/views/content-studio/pricing';
import usePlansQuery from '@/hooks/content-studio/use-plans-query';
import contentStudioStore from '@/stores/contentStudioStore';

function ContentStudio() {
  // Prefetch plans data, as this call can be quite slow.
  usePlansQuery();
  const doAndDontModalFeature = contentStudioStore(
    useShallow((state) => state.doAndDontModalFeature)
  );

  // Send purchase process ended if the user returned from web payments
  const {purchaseProcessEnded} = usePurchaseProcessEndedEvent(
    FLOW_NAMES.CONTENT_STUDIO.PRICING
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const purchaseStatus = searchParams.get('purchaseStatus');

  const [result, error] = (() => {
    if (purchaseStatus === 'success' || purchaseStatus === 'cancel') {
      return [purchaseStatus, ''];
    }
    if (purchaseStatus === 'existingSubscriber') {
      return ['failure', 'existing_subscriber'];
    }
    return ['', ''];
  })();

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('purchaseStatus');
    setSearchParams(newSearchParams);
    if (purchaseStatus) {
      const webPaymentIds = getContentLabWebPaymentIds();
      purchaseProcessEnded({
        flow_id: webPaymentIds?.flowId || '',
        presentation_id: webPaymentIds?.presentationId || '',
        process_id: webPaymentIds?.processId || '',
        product_id: webPaymentIds?.productId || '',
        result,
        error,
        product_name: webPaymentIds?.productId || '',
      });

      removeContentLabWebPaymentIds();
    }
  }, []);
  return (
    <>
      <Outlet />
      {/*
       DoAndDontModal appearance logic
       -------------------------------
       This modal is used to show the do's and don'ts for each feature.
       It is triggered by the doAndDontModalFeature state in the contentStudioStore.
       The contentStudioStore will hold an in-memory state of which features the user has seen.
       The localStorage will persist the seen state of each modal - this state will be persisted when the user clicks "Don't show again" in the modal.
       */}
      <DoAndDontModal feature={doAndDontModalFeature} />
      <ContentStudioPricingModal />
    </>
  );
}

export default ContentStudio;
